import { render, staticRenderFns } from "./inspectionhistory.vue?vue&type=template&id=1a3e2cbc&"
import script from "./inspectionhistory.vue?vue&type=script&lang=js&"
export * from "./inspectionhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports